export enum ZodiacTypes {
  AQUARIUS = 'aquarius',
  ARIES = 'aries',
  CANCER = 'cancer',
  CAPRICORN = 'capricorn',
  GEMINI = 'gemini',
  LEO = 'leo',
  LIBRA = 'libra',
  PISCES = 'pisces',
  SAGITTARIUS = 'sagittarius',
  SCORPIO = 'scorpio',
  TAURUS = 'taurus',
  VIRGO = 'virgo',
}

export const isZodiacSign = (string: string | ZodiacTypes): string is ZodiacTypes =>
  Object.values<string | ZodiacTypes>(ZodiacTypes).includes(string);
